import React, { useEffect, useMemo, useState } from 'react';
import { FormattedMessage } from 'react-intl';
import atatus from 'atatus';
import useAccounts from 'context/useAccounts';
import useGTM from 'hooks/useGTM';

import { ReactComponent as NavigationArrow } from 'assets/icons/navigation-arrow.svg';
import FocusableHeader from 'components/focusableheader/FocusableHeader';
import Link from 'components/link/Link';
import PlanList from 'components/plan/PlanList';
import { TextButtonSto } from 'components/sto';
import { AppRoutes } from 'routes';
import { getPlans } from 'services/AccountService';
import { formatAccountNumber } from 'utils/Formatter';

const PlanPage = () => {
    const {
        activeAccount: { accountNumber, merchantName },
    } = useAccounts();
    const numberOfPlans = 10;
    const [isFetchingPlans, setIsFetchingPlans] = useState(true);
    const [error, setError] = useState(null);
    const [plans, setPlans] = useState(null);
    const [index, setIndex] = useState(numberOfPlans);
    const { stepChange } = useGTM();

    useEffect(() => {
        if (plans) stepChange({ plans });
    }, [plans]);
    useEffect(() => {
        const fetchPlans = async () => {
            atatus.startTransaction('GetPlans');
            try {
                const { planSegmentData } = await getPlans(accountNumber);
                setPlans(planSegmentData);
                atatus.endTransaction('GetPlans');
            } catch (e) {
                setError(e);
                atatus.failTransaction('GetPlans');
            } finally {
                setIsFetchingPlans(false);
            }
        };
        fetchPlans();
    }, [accountNumber]);

    const paginatedPlans = useMemo(() => {
        if (plans) {
            return plans.slice(0, index);
        }
    }, [plans, index]);

    const hasMorePlans = useMemo(() => plans && plans.length >= index + 1, [index, plans]);
    const handleLoadMore = () => setIndex((i) => i + numberOfPlans);

    return (
        <section className="plan-page grey-banner">
            <div className="plan-page-heading">
                <Link aria-label="return to accounts page" to={AppRoutes.accounts}>
                    <NavigationArrow aria-label="back" className="navigation-arrow" />
                </Link>
                <FocusableHeader className="plan-page-title">
                    <FormattedMessage id="plan.details.title" />
                </FocusableHeader>
                <hr className="fs-bar orange" />
            </div>
            <div className="plan-page-content">
                <h5 className="merchantName">{merchantName}</h5>
                <p className="account-number">{formatAccountNumber(accountNumber, true)}</p>
                <PlanList error={error} isFetching={isFetchingPlans} plans={paginatedPlans} />
                {hasMorePlans && (
                    <TextButtonSto className="load-more-btn" labelKey="plan.page.load.more" onClick={handleLoadMore} />
                )}
            </div>
        </section>
    );
};

export default PlanPage;
